import { mapDropdownOptions } from "./mapDropdownOptions";

export interface BuildDynamicFilterOptionsArgs {
	ownerFilterOptions: unknown;
	countries: { data?: unknown } | undefined;
	clubManagerFilterOptions: unknown;
	contentManagerFilterOptions: unknown;
	assigneeFilterOptions: unknown;
	gameStatusFilterOptions: unknown;
}

/** Build dynamic filter options keyed by filter field name. */
export function buildDynamicFilterOptions(args: BuildDynamicFilterOptionsArgs): Record<string, Array<{ value: string | number; label: string }>> {
	const options: Record<string, Array<{ value: string | number; label: string }>> = {};

	const mappedOwners = mapDropdownOptions(args.ownerFilterOptions);
	if (mappedOwners.length > 0) {
		options.owner = mappedOwners;
	}

	if (args.countries?.data) {
		options.country = (args.countries.data as Array<{ value: string; label: string }>).map((item) => ({
			value: item.value,
			label: item.label,
		}));
	}

	const mappedClubManager = mapDropdownOptions(args.clubManagerFilterOptions);
	if (mappedClubManager.length > 0) {
		options.clubManager = mappedClubManager;
	}

	const mappedContentManager = mapDropdownOptions(args.contentManagerFilterOptions);
	if (mappedContentManager.length > 0) {
		options.contentManager = mappedContentManager;
	}

	const mappedAssignee = mapDropdownOptions(args.assigneeFilterOptions);
	if (mappedAssignee.length > 0) {
		options.assignee = mappedAssignee;
	}

	const mappedGameStatus = mapDropdownOptions(args.gameStatusFilterOptions);
	if (mappedGameStatus.length > 0) {
		options.gameStatus = mappedGameStatus;
	}

	return options;
}
